import {useMutation} from '@tanstack/react-query';
import {PostRequestUploadFileParams} from 'domain/usecases/others/facial-biometric';
import {postUploadFile} from '../services/postUploadFile';

export const useUploadFileMutation = () =>
	useMutation({
		mutationFn: (params: PostRequestUploadFileParams) => postUploadFile(params),
	});
